package com.yogaaicoach.pages.auth

import com.yogaaicoach.pages.auth.firebase.resendEmailVerificationPlatform
import kotlinx.coroutines.delay
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import react.useState
import web.cssom.ClassName

internal external interface VerifyEmailPageProps : Props {
    var email: String
    var onGoToLogin: () -> Unit
}

// Pixel-matched against VerifyEmailScreen.kt — a plain centered text block, no logo/card.
internal val VerifyEmailPage = FC<VerifyEmailPageProps> { props ->
    var showSentMessage by useState(false)

    div {
        className = ClassName("auth-message-page")

        p { className = ClassName("auth-message-title"); +"Thank you for signing up!" }
        p { className = ClassName("auth-message-text"); +"We've sent a verification email to ${props.email}." }
        p { className = ClassName("auth-message-text auth-message-bold"); +"Please click the link in that email to verify your account before logging in." }
        p { className = ClassName("auth-message-small"); +"If you don't see the email, check your spam folder or click \"Resend Verification Email\"." }

        button {
            className = ClassName("primary-button")
            +"Go to Login"
            onClick = { props.onGoToLogin() }
        }

        button {
            className = ClassName("text-button")
            +"Resend Verification Email"
            onClick = {
                scope.launch {
                    showSentMessage = false
                    resendEmailVerificationPlatform()
                    showSentMessage = true
                    delay(4000L)
                    showSentMessage = false
                }
            }
        }

        if (showSentMessage) {
            p { className = ClassName("auth-message-info"); +"A new verification email has been sent." }
        }
    }
}
